import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  AdditionalOrderColumn,
  FilterDefinitionType,
  OrderStatus,
  OrdersTab,
} from 'enums';
import { useOrderQueryFilters } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { FilterDefinition, OrderFilters } from 'types';
import { orderUtils } from 'utils';

import { ManageOrdersList } from '../ManageOrderList';

export const ActiveOrders: React.FC = () => {
  const { t: tFields } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders.table.columns',
  });

  useOrderQueryFilters();

  const additionalFilters: FilterDefinition<OrderFilters>[] = useMemo(
    () => [
      {
        label: tFields('status'),
        name: 'status',
        type: FilterDefinitionType.OrderStatus,
        orderStatuses: [
          OrderStatus.New,
          OrderStatus.Requisites,
          OrderStatus.TraderConfirm,
          OrderStatus.CustomerConfirm,
        ],
        getDisplayName: (value: OrderStatus) =>
          orderUtils.getStatusLabel(value),
      },
    ],
    [tFields],
  );

  return (
    <ManageOrdersList
      tab={OrdersTab.Active}
      additionalColumns={[
        AdditionalOrderColumn.StatusActive,
        AdditionalOrderColumn.TraderCard,
        AdditionalOrderColumn.OrderProcessedBy,
      ]}
      additionalFilters={additionalFilters}
    />
  );
};
